<template>
    <div>
        <vx-card>
            <vs-tabs>
                <vs-tab :label="$t('dashboard.positionInformation')">
                    <div>
                        <div slot="no-body" class="tabs-container px-6 pt-6">
                            <div class="vx-row mt-4">
                                <div class="vx-col md:w-1/3 w-full">
                                    <vs-input class="w-full" :label="$t('dashboard.positionName')" :placeholder="$t('dashboard.positionName')"
                                              v-model="positionInfo.name" name="namePosition" />
                                </div>
                                <div class="vx-col md:w-2/3 w-full">
                                    <vs-input class="w-full" :label="$t('library.description')" :placeholder="$t('library.description')"
                                              v-model="positionInfo.description" name="description" />
                                </div>
                            </div>
                            <br>
                            <br>
                        </div>
                    </div>
                </vs-tab>
                <vs-tab :label="$t('shareGroupCamera.permission')">
                    <div>
                        <v-tree ref='tree' @node-select="saveNodeSelected" @node-check="saveNodeSelected"
                                :data='treeData' :multiple="true" :halfcheck='true' />
                    </div>
                </vs-tab>
            </vs-tabs>
            <!-- Save & Reset Button -->
            <div class="vx-row">
                <div class="vx-col w-full">
                    <div class="mt-8 flex flex-wrap items-center justify-end mb-5">
                        <vs-button class="ml-auto mt-2" @click="saveChanges"
                                   v-if="((userInfo.userRole == 'organization' || positionInfo.organizationBranchId) && isPermissionUpdate())"
                                   :disabled="!validateForm"> {{isUpdate ? $t('button.update') :  $t('button.create') }}
                        </vs-button>
                        <vs-button class="ml-4 mt-2" type="border" color="warning" @click="leaveList">{{$t('button.back') }}
                        </vs-button>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css">

</style>
<script>

import utils from "../../../components/utils";
import { VTree } from 'vue-tree-halower'
import 'quill/dist/quill.snow.css';
import Vue from 'vue'
import { isAPI } from '../../../store/permission'
import { constAPI } from '../../../store/constant'

Vue.use(VTree)

export default {
    components: {
        utils,
    },
    data() {
        return {
            userInfo: {},
            isUpdate: false,
            positionInfo: {
                name: '',
                organizationId: 0,
                permission: [],
                description: '',
                organizationBranchId: null
            },
            positionId: 0,
            treeData: [{
                title: "Danh sách quyền hạn",
                expanded: true,
                children: []
            }],
            listPermissionCheck: []
        }
    },
    created() {
        this.initScreen();
        let timeDuration = 30, timeSpans = [];
        for (let i = 0; i < 24 * 60; i = i + timeDuration) {
            timeSpans.push({ value: i, label: utils.minuteToHour(i) });
        }
        this.timeSpans = timeSpans;
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.map(x => {
            return { label: x.organizationBranchName, value: x.id }
        });
        this.positionInfo = {
            name: '',
            organizationId: 0,
            permission: [],
            description: '',
            organizationBranchId: null
        };
        let userInfo = JSON.parse(localStorage.getItem('userInfo'));
        if (userInfo.userRole != 'organization') this.positionInfo.organizationBranchId = userInfo.organizationBranchId;
    },
    watch: {
        '$store.state.windowWidth'(val) {
            if (val <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.isUpdateEmployee'(val) {
            if (val) {
                this.initScreen();
                this.$store.commit('UPDATE_EMPLOYEE', false);
            }
        }
    },
    computed: {
        validateForm() {
            return !this.errors.any()
        },
    },
    methods: {
        isPermissionUpdate() {
            return isAPI(this, constAPI.positinon_edit)
        },
        successUpload() {
            this.$vs.notify({
                color: 'success',
                title: 'Upload Success',
                text: 'Lorem ipsum dolor sit amet, consectetur'
            })
        },
        onOptionClick({ option, addTag }) {
            addTag(option)
            this.search = ''
        },
        getLabelString(object) {
            return (object && object.label) || 'Chưa xác định';
        },
        async initScreen() {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            try {
                this.userInfo = userInfo;
                if (!this.$route.query.positionId) {
                    this.isUpdate = false;
                    this.getListPermissions();
                    return
                }
                this.$vs.loading();
                const res = await this.$oauth.get(`position/find-by-id/${this.$route.query.positionId}`)
                let positionDetail = res.data;
                this.positionInfo.name = positionDetail.name;
                this.positionInfo.permission = positionDetail.permission;
                this.listPermissionCheck = positionDetail.permission.map(t => t.id);
                this.positionInfo.description = positionDetail.description;
                this.positionInfo.organizationBranchId = positionDetail.organizationBranchId;
                this.positionId = positionDetail.id;
                this.isUpdate = true;
                this.$vs.loading.close();
                this.getListPermissions();
            } catch (err) {
                this.isUpdate = false;
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger',
                });
            }
        },
        async getListPermissions() {
            try {
                this.$vs.loading();
                let res = await this.$oauth.get('permission-function-global/find-all')
                let listGroup = res.data.map(t => t.groupPermission)
                listGroup = [...new Set(listGroup)]
                let treeDataTmp = []
                listGroup.forEach(t => {
                    let listChildren = []
                    listChildren = res.data.filter(item => item.groupPermission == t).map(item => {
                        let checked = this.positionInfo.permission.some(per => per.id == item.id)
                        return {
                            title: item.functionAlias,
                            id: item.id,
                            checked
                        }
                    })
                    treeDataTmp.push(
                        {
                            title: t,
                            expanded: true,
                            children: listChildren
                        }
                    )
                })
                treeDataTmp.map(el => {
                    if (el.title == "Dashboard") {
                        el.children.map(x => {
                            if (x.title != 'Dữ liệu xin nghỉ') {
                                x.checked = true
                                this.listPermissionCheck.push(x.id)
                                x.chkDisabled = true
                                return x
                            }
                        })
                        // el.visible = false
                        el.chkDisabled = true
                    }
                    return el
                })
                this.treeData = [{
                    title: "Danh sách quyền hạn",
                    expanded: true,
                    children: [...treeDataTmp]
                }];
                this.$vs.loading.close();
            } catch (err) {
                console.log('getListPermissions error', err)
                this.$vs.loading.close();
            }
        },

        saveNodeSelected() {
            let listNodesSelected = []
            if (this.$refs.tree) {
                listNodesSelected = this.$refs.tree.getCheckedNodes();
            }

            this.listPermissionCheck = []
            listNodesSelected.forEach(per => {
                if (per.id) {
                    this.listPermissionCheck.push(per.id)
                }
            })
        },

        async saveChanges(evt) {
            evt.preventDefault();
            try {
                if (!this.validateForm) return;

                const result = await this.$validator.validateAll();
                if (!result) return;

                if (!this.positionInfo.name.trim()) {
                    return this.$vs.notify({
                        text: 'Vui lòng nhập tên chức vụ',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger',
                    });
                }

                let currentUser = JSON.parse(localStorage.getItem('userInfo') || '{}')

                let url = `/position/create`;

                let params = { ...this.positionInfo, organizationId: currentUser.organization.id }
                params.permission = this.listPermissionCheck;

                if (this.isUpdate) {
                    url = `position/update/${this.positionId}`
                    params = { ...params, id: this.positionId }
                }

                this.$vs.loading();
                this.$oauth.post(url, params).then(() => {
                    this.$vs.loading.close();
                    this.leaveList();
                    this.$vs.notify({
                        color: 'success',
                        text: `${this.isUpdate ? 'Cập nhật' : 'Thêm'} thành công`,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            } catch (ex) {
                console.log(ex);
            }
        },
        leaveList() {
            this.$router.push(`/user/manage-position`).catch(() => {
            })
        }
    },
}
</script>

<style scoped>
.input-content {
    height: 200px !important;
}
</style>

<style>
.halo-tree .tree-close:after {
    content: '>' !important;
}
</style>
